/*
  ** Home.jsx **
  Monta a página inicial
*/
import React, { useEffect } from "react";
import MasterPage from "../components/MasterPage";

const VantagensStatic = React.lazy(() =>
  import("../components/home/VantagensStatic")
);
const FAQ = React.lazy(() => import("../components/lpConteudos/FAQ"));

import AOS from "aos";
import "aos/dist/aos.css";
import SEO from "../components/home/SEO";
import NewHeader from "../components/new-home/NewHeader";
import Lojinha from "../components/new-home/Lojinha";
import LojinhaMobile from "../components/new-home/LojinhaMobile";
import NewHighlights from "../components/new-home/NewHighlights";
import Beneficios from "../components/new-home/Beneficios";
import Vantagens from "../components/new-home/Vantagens";

import HomeVariables from "../data/home/homeVariables";
import GlobalVariables from "../data/globalVariables";

import useQueryLpData from "../hooks/useQueryLpData";
import useQueryHtmlData from "../hooks/useQueryHtmlData";

import PlanosJSON from "../data/planos-nova-pv.json";
import ContentJSON from "../data/conteudos-oferecidos.json";
import SinglesJSON from "../data/lojinha-nova-pv.json";

import { useMobile } from "../hooks/useMobile";
import PlansMobile from "../components/updated/PlansMobile";
import PlansTabs from "../components/updated/PlansTabs";

function Home() {
  useEffect(() => {
    AOS.init();
  }, []);

  let content = null;

  const contentResponse = useQueryLpData("CONTEUDOS", "");
  if (contentResponse.data) {
    content = contentResponse.data;
  } else {
    content = ContentJSON;
  }

  const responseHTML = useQueryHtmlData(
    "HOME FAQ",
    "https://jsuol.com/p/pp/uol-play/publicador/faqs/faq-new-home.html"
  );

  const { isMobile } = useMobile(1270);

  return (
    <MasterPage namePage="home">
      {HomeVariables?.seo && <SEO content={HomeVariables?.seo} />}

      <NewHeader />

      {isMobile ? (
        <PlansMobile
          content={PlanosJSON?.benefits}
          planos={PlanosJSON?.plans}
          title="Temos um combo especial para você curtir um universo de conteúdos"
        />
      ) : (
        <PlansTabs
          content={PlanosJSON?.benefits}
          planos={PlanosJSON?.plans}
          planIndex={0}
          title="Temos um combo especial para você curtir um universo de conteúdos"
          hasSubtitle
          hasReceba40
        />
      )}

      {isMobile ? (
        <LojinhaMobile channels={SinglesJSON?.channels} />
      ) : (
        <Lojinha channels={SinglesJSON?.channels} />
      )}

      <NewHighlights />

      <Vantagens />

      <Beneficios />

      {GlobalVariables?.faq && (
        <React.Suspense>
          {/* <Duvidas content={HomeVariables?.faq} /> */}
          <FAQ metaData={GlobalVariables?.faq} htmlData={responseHTML?.data} />
        </React.Suspense>
      )}
    </MasterPage>
  );
}

export default Home;
